import type { RootState } from "@redux/types";

import { B2bUserType, UserContext } from "shared-types/user";

export const userUuidSelector = (state: RootState) => state?.user.userUuid;

export const userTypeSelector = (state: RootState) => state?.user.userType;

export const userContextSelector = (state: RootState) => {
	const userTypeMap = {
		[UserContext.BAM.toUpperCase()]: UserContext.BAM,
		[UserContext.TSL.toUpperCase()]: UserContext.TSL,
	};
	return userTypeMap[
		state?.user.userType?.toUpperCase() as keyof typeof userTypeMap
	];
};

export const withBamLayoutSelector = (state: RootState) =>
	state?.user.userType === B2bUserType.BAM || undefined;
